import styled, { css } from 'styled-components';
import { getDimension } from 'styled/helpers/getDimension';

export const TextContainer = styled.div<{ isHero?: boolean }>`
  ${({ isHero }) =>
    isHero &&
    css`
      flex: 2;
      margin-right: ${getDimension('size10')};
    `}
`;
